import { FC, memo } from "react";

import useHideBodyScroll from "hooks/useHideBodyScroll";

type PropTypes = {
  isLoading: boolean;
  inline?: boolean;
};

const Loader: FC<PropTypes> = ({ isLoading, inline }) => {
  useHideBodyScroll(isLoading && !inline);

  if (!isLoading) return null;

  if (inline) {
    return (
      <div className="inline-loader">
        <BasedLoader />
      </div>
    );
  }

  return (
    <div className="global-loader">
      <BasedLoader />
    </div>
  );
};

const BasedLoader = () => {
  return (
    <section className="loader">
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
    </section>
  );
};

export default memo(Loader);
